import { render } from "./uploadLogo.vue?vue&type=template&id=7c16760c&scoped=true"
import script from "./uploadLogo.vue?vue&type=script&lang=js"
export * from "./uploadLogo.vue?vue&type=script&lang=js"

import "./uploadLogo.vue?vue&type=style&index=0&id=7c16760c&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c16760c"]])

export default __exports__